// Mock data for AIP Booking

export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1549294413-26f195200c16?w=1920&q=80",
    tag: "MEMBERS-ONLY RATES",
    title: "Save more on every stay",
    subtitle: "Enjoy up to 20% off when you book direct as an AIP Rewards member.",
    cta: "Join AIP Rewards",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1630587148265-761cbd139043?w=1920&q=80",
    tag: "SUMMER ESCAPES",
    title: "Discover unforgettable destinations",
    subtitle: "From city hideaways to sun-kissed beaches — plan your next getaway with AIP.",
    cta: "Explore offers",
  },
  {
    id: 3,
    image: "https://images.pexels.com/photos/34496713/pexels-photo-34496713.jpeg?w=1920&q=80",
    tag: "NEW OPENINGS",
    title: "Experience iconic hotels worldwide",
    subtitle: "Nine unique brands. One rewarding stay. Welcome to AIP Booking.",
    cta: "Find your hotel",
  },
];

export const brands = [
  { id: "collection", name: "AIP Collection", tagline: "Iconic, luxury boutique hotels", image: "https://images.pexels.com/photos/34559240/pexels-photo-34559240.jpeg?w=800&q=80" },
  { id: "blu", name: "AIP Blu", tagline: "Stylish, upper-upscale hotels", image: "https://images.pexels.com/photos/36916378/pexels-photo-36916378.jpeg?w=800&q=80" },
  { id: "red", name: "AIP RED", tagline: "Bold, playful lifestyle stays", image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80" },
  { id: "signature", name: "AIP Signature", tagline: "Upscale hotels with local character", image: "https://images.pexels.com/photos/34496701/pexels-photo-34496701.jpeg?w=800&q=80" },
  { id: "resort", name: "AIP Resorts", tagline: "Beach, mountain and leisure retreats", image: "https://images.pexels.com/photos/15490065/pexels-photo-15490065.jpeg?w=800&q=80" },
  { id: "inn", name: "AIP Inn", tagline: "Comfortable, upper-midscale hotels", image: "https://images.pexels.com/photos/28855455/pexels-photo-28855455.jpeg?w=800&q=80" },
];

export const destinations = [
  { id: 1, city: "Dubai", country: "United Arab Emirates", properties: 24, image: "https://images.pexels.com/photos/18341554/pexels-photo-18341554.jpeg?w=800&q=80" },
  { id: 2, city: "Paris", country: "France", properties: 18, image: "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=800&q=80" },
  { id: 3, city: "London", country: "United Kingdom", properties: 22, image: "https://images.pexels.com/photos/19612315/pexels-photo-19612315.jpeg?w=800&q=80" },
  { id: 4, city: "Tokyo", country: "Japan", properties: 15, image: "https://images.unsplash.com/photo-1513407030348-c983a97b98d8?w=800&q=80" },
  { id: 5, city: "New York", country: "United States", properties: 31, image: "https://images.pexels.com/photos/5822697/pexels-photo-5822697.jpeg?w=800&q=80" },
  { id: 6, city: "Mumbai", country: "India", properties: 12, image: "https://images.unsplash.com/photo-1604928141064-207cea6f571f?w=800&q=80" },
];

export const offers = [
  {
    id: 1,
    tag: "Members Exclusive",
    title: "Save up to 20% on your next stay",
    description: "Book direct as an AIP Rewards member and enjoy exclusive savings on stays at over 1,100 hotels worldwide.",
    image: "https://images.pexels.com/photos/3852252/pexels-photo-3852252.jpeg?w=1200&q=80",
    validity: "Book by 30 Sep 2025 · Stay by 15 Dec 2025",
  },
  {
    id: 2,
    tag: "Family Getaways",
    title: "Kids stay and eat free",
    description: "Make memories with the whole family. Kids under 12 stay and dine complimentary at participating resorts.",
    image: "https://images.pexels.com/photos/8922187/pexels-photo-8922187.jpeg?w=1200&q=80",
    validity: "Valid across AIP Resorts worldwide",
  },
  {
    id: 3,
    tag: "Spa & Wellness",
    title: "Reset and recharge weekends",
    description: "Enjoy a spa credit, late checkout, and daily breakfast on wellness stays of two nights or more.",
    image: "https://images.pexels.com/photos/7365434/pexels-photo-7365434.jpeg?w=1200&q=80",
    validity: "Selected AIP Collection hotels",
  },
  {
    id: 4,
    tag: "Dine & Discover",
    title: "Culinary journeys",
    description: "Complimentary chef's tasting menu when you book a suite of two nights or more.",
    image: "https://images.pexels.com/photos/460537/pexels-photo-460537.jpeg?w=1200&q=80",
    validity: "Selected city hotels",
  },
];

export const rewardBenefits = [
  { tier: "Club", nights: "0–8 nights", perks: ["Members-only rates", "Free Wi-Fi", "Late checkout on request"] },
  { tier: "Silver", nights: "9–29 nights", perks: ["10% bonus points", "Welcome amenity", "Room upgrade on availability"] },
  { tier: "Gold", nights: "30–59 nights", perks: ["25% bonus points", "Guaranteed room type", "Early check-in on request"] },
  { tier: "Platinum", nights: "60+ nights", perks: ["50% bonus points", "Suite upgrade on availability", "Personal concierge"] },
];

export const footerLinks = {
  Company: ["About AIP Booking", "Careers", "Newsroom", "Investor Relations", "Sustainability"],
  Support: ["Contact Us", "Help Center", "Book with Confidence", "Modify Reservation", "Group Bookings"],
  Explore: ["All Hotels", "All Destinations", "Meetings & Events", "Weddings", "Gift Cards"],
  Rewards: ["Join AIP Rewards", "Member Benefits", "Redeem Points", "Partner Offers", "Elite Status"],
};

export const testimonials = [
  { id: 1, name: "Aditi Sharma", location: "Mumbai, India", quote: "AIP Rewards made our anniversary trip effortless. From suite upgrades to late checkout, every detail was thoughtful.", rating: 5 },
  { id: 2, name: "James O'Connor", location: "London, UK", quote: "I travel weekly for work and AIP is the only program that consistently delivers. Platinum benefits are worth every night.", rating: 5 },
  { id: 3, name: "Sofia Martinez", location: "Barcelona, Spain", quote: "Booking direct saved us 20% and got us the best room on the floor. Truly a members-first experience.", rating: 5 },
];

export const CONTACT_NUMBER = "+91 98706 27398";
